export const WORKSPACE_SEGMENT_CONFIG_KEY = "workspace.segment";

export const WorkspaceSegments = Object.freeze({
  Generic: "generic",
  PassengerTransport: "passenger_transport",
  AutoParts: "auto_parts",
});

export const ALL_WORKSPACE_SEGMENTS = Object.freeze(Object.values(WorkspaceSegments));

export function normalizeWorkspaceSegment(raw) {
  const s = String(raw || "").trim().toLowerCase();
  return ALL_WORKSPACE_SEGMENTS.includes(s) ? s : WorkspaceSegments.Generic;
}

